"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _Link = _interopRequireDefault(require("@sprinx/react-mui-components/Link"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: (0, _extends2.default)({}, theme.typography.body1, {
      color: theme.palette.grey[800],
      fontWeight: 500,
      display: 'flex',
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5)
    }),
    icon: {
      marginRight: theme.spacing(1)
    }
  };
}, {
  name: 'PageBreadcrumbsItem'
});

function PageBreadcrumbsItem(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      Icon = _ref.Icon,
      label = _ref.label,
      to = _ref.to,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "Icon", "label", "to"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  return /*#__PURE__*/_react.default.createElement(_Link.default, (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className),
    to: to
  }), Icon && /*#__PURE__*/_react.default.createElement(Icon, {
    className: classes.icon
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, null, t(label, {
    acceptString: true
  })));
}

process.env.NODE_ENV !== "production" ? PageBreadcrumbsItem.propTypes = {
  classes: _propTypes.default.shape({
    icon: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  Icon: _propTypes.default.elementType,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.shape({
    language: _propTypes.default.string.isRequired,
    text: _propTypes.default.string
  }))]),
  to: _propTypes.default.string
} : void 0;
PageBreadcrumbsItem.defaultProps = {
  classes: undefined,
  className: undefined,
  Icon: undefined,
  label: undefined,
  to: undefined
};
var _default = PageBreadcrumbsItem;
exports.default = _default;